import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    gov_title: 'Централизованная база данных подведомственных учреждений Beyim Smart QR',
    gov_subtitle: 'Государственные услуги',
  },
  kk: {
    gov_title: 'Beyim Smart QR қарамағындағы мекемелердің орталықтандырылған дерекқоры',
    gov_subtitle: 'Мемлекеттік қызметтер',
  }
});
